import { PerfromanceDetailView } from './PerfromanceDetailView'

export const PerformanceContainer: React.FC = () => {
  return <PerfromanceDetailView />
}
